import useFeatures from './useFeatures';
export default function useFeature(feature) {
    const features = useFeatures();
    return features ? features[feature] : null;
}
